import React, { useEffect, useState } from "react";
import PublicSection from "../../components/PublicLayer/PublicSection";
import FormHeader from "../../components/PublicLayer/FormHeader";
import useForm, { Form } from "../../components/controls/useForm";
import FormLabel from "../../components/HtmlMarkup/FormLabel";
import Controls from "../../components/controls/control";
import ErrorMessage from "../../components/Ui/ErrorMessage";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLoginAdminMutation } from "../../features/Auth/authApi";
import { userLogOut } from "../../features/Auth/authSlice";

const initializeValue = {
  email: "",
  password: "",
};
export default function AdminLogin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  const [adminLogin, { isSuccess, isError, error }] = useLoginAdminMutation();
  const { values, setValues, handleInputChange, resetForm } =
    useForm(initializeValue);
  const [errors, setErrors] = useState(false);
  useEffect(() => {
    if (isSuccess) {
      if (auth?.user?.role === "admin") {
        resetForm(initializeValue);
        navigate("/admin/dashboard");
      } else {
        dispatch(userLogOut());
        localStorage.clear();
        setErrors("Email or password not matched !!");
      }
    } else if (isError) {
      setErrors(error.data);
    }
  }, [isSuccess, isError, auth, navigate]);
  const handleSubmit = (e) => {
    console.log("Admin");
    e.preventDefault();
    adminLogin({
      ...values,
      role: "admin",
    });
  };
  return (
    <PublicSection>
      <FormHeader title={"Sign in to Admin Account"} />
      <Form onSubmit={handleSubmit} className="mt-8 space-y-6">
        <div className="rounded-md shadow-sm -space-y-px">
          <div>
            <FormLabel htmlFor="email-address" className="sr-only">
              Email address
            </FormLabel>
            <Controls.Input
              id="email-address"
              name="email"
              type="email"
              autocomplete="email"
              className="login-input rounded-t-md"
              placeholder="Email address"
              value={values.email}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <FormLabel htmlFor="password" className="sr-only">
              Password
            </FormLabel>
            <Controls.Input
              id="password"
              name="password"
              type="password"
              autocomplete="current-password"
              className="login-input rounded-b-md"
              placeholder="Password"
              value={values.password}
              onChange={handleInputChange}
            />
          </div>
        </div>

        {errors && <ErrorMessage error={errors} />}
        <div className="flex items-center justify-end">
          <div className="text-sm">
            <a
              href="#"
              className="font-medium text-violet-600 hover:text-violet-500"
            >
              Forgot your password?
            </a>
          </div>
        </div>

        <div>
          <Controls.Button
            type="submit"
            text="Sign in"
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
          />
        </div>
      </Form>
    </PublicSection>
  );
}
